module.exports = __webpack_public_path__ + "img/blog-15-2.61e1286b.webp";